import Avramenko from 'assets/illustrations/mentors/avramenko.webp';
import Zaharkov from 'assets/illustrations/mentors/zaharkov.webp';
import Bojko from 'assets/illustrations/mentors/bojko.webp';
import Kopcova from 'assets/illustrations/mentors/kopcova.webp';
import Shaulo from 'assets/illustrations/mentors/shaulo.webp';
import Antonenko from 'assets/illustrations/mentors/antonenko.webp';
import Laenko from 'assets/illustrations/mentors/laenko.webp';
import Pavlenko from 'assets/illustrations/mentors/pavlenko.webp';

export const mentorsCardsData = [
  {
    name: 'Андрей Авраменко',
    role: 'Генеральный директор',
    text: 'Анализировать рынок и участвовать в принятии стратегических решений по развитию бизнеса',
    icon: Avramenko,
    iconProps: {
      w: { mobile: '289px', tablet: '330px', laptop: '388px' },
      h: 'auto',
      bottom: { mobile: '-110px', tablet: '0', laptop: '-1px' },
      right: { mobile: 'calc(50% - (289px / 2))', tablet: '-64px', laptop: '-84px' },
    },
  },
  {
    name: 'Иван Захарков',
    role: 'Коммерческий директор',
    text: 'Анализировать драйверы роста компании: прибыльность направлений и потенциал новых рынков',
    icon: Zaharkov,
    iconProps: {
      w: { mobile: '290px', tablet: '330px', laptop: '385px' },
      h: 'auto',
      bottom: { mobile: '-109px', tablet: '0', laptop: '-2px' },
      right: { mobile: 'calc(50% - (290px / 2))', tablet: '-64px', laptop: '-76px' },
    },
    textsContainerProps: { maxW: { tablet: '275px', laptop: '280px' } },
  },
  {
    name: 'Дарья Бойко',
    role: 'Руководитель департамента по подбору персонала',
    text: 'Анализировать рынок ИT‑специалистов и строить стратегию найма для привлечения сильных кандидатов',
    icon: Bojko,
    iconProps: {
      w: { mobile: '240px', tablet: '268px', laptop: '330px' },
      h: 'auto',
      bottom: { mobile: '-123px', tablet: '0', laptop: '-25px' },
      right: { mobile: 'calc(50% - (240px / 2))', tablet: '-30px', laptop: '-47px' },
    },
    textsContainerProps: { maxW: { tablet: '275px', laptop: '320px' } },
  },
  // Убрана карточка в соответствии с задачей AST-7600
  // {
  //   name: 'Ирина Копцова',
  //   role: 'Руководитель программы развития лидеров',
  //   text: 'Развивать систему стажировок: от привлечения кандидатов до оценки их эффективности',
  //   icon: Kopcova,
  //   iconProps: {
  //     w: { mobile: '240px', tablet: '275px', laptop: '330px' },
  //     h: 'auto',
  //     bottom: { mobile: '-150px', xm: '-123px', tablet: '-14px', laptop: '-29px' },
  //     right: { mobile: 'calc(50% - (240px / 2))', tablet: '-34px', laptop: '-36px' },
  //   },
  // },
  {
    name: 'Анастасия Шауло',
    role: 'Руководитель департамента ресурсного менеджмента',
    text: 'Управлять ресурсами компании: людьми, технологиями и процессами для повышения эффективности',
    icon: Shaulo,
    iconProps: {
      w: { mobile: '240px', tablet: '274px', laptop: '325px' },
      h: 'auto',
      bottom: { mobile: '-150px', xm: '-123px', tablet: '-13px', laptop: '-21px' },
      right: { mobile: 'calc(50% - (240px / 2))', tablet: '-29px', laptop: '-32px' },
    },
    textsContainerProps: { maxW: { tablet: '275px', laptop: '290px' } },
  },
  {
    name: 'Екатерина Антоненко',
    role: 'Руководитель департамента подбора и адаптации персонала',
    text: 'Анализировать работу ИT‑специалистов и перераспределять их между проектами',
    icon: Antonenko,
    iconProps: {
      w: { mobile: '255px', tablet: '300px', laptop: '350px' },
      h: 'auto',
      bottom: { mobile: '-150px', xm: '-104px', tablet: '-2px', laptop: '-1px' },
      right: { mobile: 'calc(50% - (255px / 2))', tablet: '-38px', laptop: '-38px' },
    },
  },
  {
    name: 'Евгений Лаенко',
    role: 'Директор по управлению проектами',
    text: 'Разобраться в экономике проектов: считать прибыль, управлять командами и повышать эффективность',
    icon: Laenko,
    iconProps: {
      w: { mobile: '282px', tablet: '325px', laptop: '388px' },
      h: 'auto',
      bottom: { mobile: '-125px', tablet: '-2px', laptop: '-9px' },
      right: { mobile: 'calc(50% - (282px / 2))', tablet: '-49px', laptop: '-61px' },
    },
    textsContainerProps: { maxW: { tablet: '275px', laptop: '280px' } },
  },
  {
    name: 'Ирина Павленко',
    role: 'Руководитель отдела обучения и развития',
    text: 'Создавать и внедрять программы обучения для ИT‑команд и менеджмента',
    icon: Pavlenko,
    iconProps: {
      w: { mobile: '237px', tablet: '266px', laptop: '319px' },
      h: 'auto',
      bottom: { mobile: '-125px', xm: '-116px', tablet: '0', laptop: '-9px' },
      right: { mobile: 'calc(50% - (237px / 2))', tablet: '-25px', laptop: '-40px' },
    },
  },
];
